import { useState } from "react";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { ReservationPayment } from "../../../types/common.types";
import FileInput from "../../common/FileInput";
import SellerService from "../../../services/seller.service";
import jsonToFormData from "../../../utils/jsonToFormData";
import { useSeller } from "../../../context/seller";
import { AiOutlineClose } from "react-icons/ai";

export default function CreatePayment() {
    const { createPaymentReservationId, createPaymentGroupId, setCreatePaymentReservationId, 
        setCreatePaymentGroupId, setIsCreatePaymentModalOpen } = useSeller()
    const [data, setData] = useState<ReservationPayment>({
        reservation_id: createPaymentReservationId || undefined,
        group_id: createPaymentGroupId || undefined,
    } as ReservationPayment);
    function onChange(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const name = e.target.name as keyof ReservationPayment;
        let value: any
        if (e.target.type === 'number') {
            value = Number(e.target.value)
        } else {
            value = e.target.value
        }
        setData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    function onChangeFiles(newFile: File | undefined, name: keyof ReservationPayment) {
        console.log(newFile)
        setData(prevData => ({...prevData, [name]: newFile}))
    }

    async function registerPayment(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            let submittingData: ReservationPayment = {
                amount: data.amount ||0,
                amount_tickets: data.amount_tickets || 0,
                remarks: data.remarks || '',
                pic: data.pic || ''
            } as ReservationPayment
            if (createPaymentReservationId) submittingData['reservation_id'] = createPaymentReservationId
            if (createPaymentGroupId) submittingData['group_id'] = createPaymentGroupId
            const formattedData = jsonToFormData(submittingData)
            const response = await SellerService.createReservationPayment(formattedData)
            console.log(response);
            window.location.reload()
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <Modal
        onSubmit={registerPayment}
        >
            <div className="close"
            onClick={() => {
                setIsCreatePaymentModalOpen(false)
                setCreatePaymentReservationId('')
                setCreatePaymentGroupId('')
            }}
            >
                <AiOutlineClose/>
            </div>
            <h1>Create Payment</h1>
            <GeneralInput
            label="Pagado de tour"
            name="amount"
            type="number"
            value={data.amount || ''}
            placeholder="10.000"
            onChange={onChange}
            />
            <GeneralInput
            label="Pagado de entrada"
            name="amount_tickets"
            type="number"
            value={data.amount_tickets || ''}
            placeholder="10.000"
            onChange={onChange}
            style={{margin: '10px 0'}}
            />
            <GeneralInput
            label="Remarks"
            name="remarks"
            type="text"
            value={data.remarks || ''}
            placeholder="Pago del 10% del tour"
            onChange={onChange}
            />
            <FileInput
            style={{margin: '10px 0'}}
            value={data.pic}
            deleteFile={() => onChangeFiles(undefined, 'pic')}
            accept=".png, .jpg, .jpeg, .heic"
            onChange={(newFile: File) => onChangeFiles(newFile, 'pic')}
            />
            <div className="actions">
                <button>
                    Create
                </button>
            </div>
        </Modal>
    )
}